import Block from "components/Block";
import BlockCard from "components/common/Card/BlockCard";
import BlockCardSkeleton from "components/common/Card/BlockCard/BlockCardSkeleton";
import HomeImages from "context/HomeMajorImages";
import React, { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSuggestions } from "store/api/LifeChoiceBlocks";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";

const SuggestionsBlock = () => {
  const { dir, language } = useAppSelector(getSettings);
  const { data, isLoading, refetch } = useSuggestions();
  const { pathname } = useLocation();

  useEffect(() => {
    refetch();
  }, [pathname]);

  const renderItem = useCallback(
    (block) =>
      block ? (
        <BlockCard ariaCardSize="sm" item={block} />
      ) : (
        <BlockCardSkeleton ariaCardSize="sm" />
      ),
    [data]
  );

  if (!data || isLoading) return null;

  return (
    <>
      <div
        className={`suggestion | container mt-6 lg:mt-14 !pt-0 !px-0 lg:px-auto`}
        dir={dir}
        lang={language}
      >
        <Block
          block={{
            lifeChoices: data,
          }}
          carouselItemRender={renderItem}
        />
      </div>
    </>
  );
};

const SuggestionsBlockWrapper = () => (
  <HomeImages>
    <SuggestionsBlock />
  </HomeImages>
);

export default SuggestionsBlockWrapper;
